// A draft choice disables the menu immediately; saved independent accounts stay
// disabled until a company selection has actually been saved.
export function crewSearchDisabled(user, draftWorkforceKind) {
  if (user?.roles?.includes('super_admin')) return false;
  return user?.workforce_kind === 'independent' || draftWorkforceKind === 'independent';
}
export const crewSearchReason = 'Find Crew is for contractor companies. Independent technicians receive job requests and crew invitations.';
